'use client';

import Script from 'next/script';

const publicKey = process.env.NEXT_PUBLIC_AFFIRM_PUBLIC_KEY;

export default function AffirmScript() {
  if (!publicKey) return null;

  return (
    <Script
      id="affirm-sdk"
      src="https://cdn1.affirm.com/js/v2/affirm.js"
      strategy="afterInteractive"
      onLoad={() => {
        window._affirm_config = { public_api_key: publicKey, locale: 'en_US', country_code: 'USA' };
        window.dispatchEvent(new Event('affirm:ready'));
      }}
    />
  );
}
